import * as React from 'react';
import { clsx } from 'clsx';
import styles from './styles.module.css';
import { UIText1, UIText2, UIText3 } from '../../../../typography';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const StepperWrapper = props => {
  const {
    title,
    children,
    errorMessage,
    fullWidth,
    disabled,
    invalid,
    dataTestId
  } = props;
  const containerClasses = clsx(styles['container'], {
    [styles['container--fullWidth']]: fullWidth,
    [styles['container--fixed']]: !fullWidth,
    [styles['container--withLabel']]: !!title,
    [styles['container--noLabel']]: !title,
    [styles['container--withError']]: errorMessage && invalid && !disabled
  });
  const StepperLabel = fullWidth ? UIText2 : UIText1;
  return /*#__PURE__*/_jsxs("div", {
    className: containerClasses,
    "data-testid": dataTestId,
    children: [title && /*#__PURE__*/_jsx("div", {
      className: clsx(styles['stepper-label'], fullWidth && styles['stepper-label--fullWidth']),
      "data-testid": "".concat(dataTestId, "-label"),
      children: /*#__PURE__*/_jsx(StepperLabel, {
        color: disabled ? 'text-primary-disabled' : 'text-primary-default',
        children: title
      })
    }), children, errorMessage && invalid && !disabled && /*#__PURE__*/_jsx("div", {
      className: styles['stepper-caption'],
      "data-testid": "".concat(dataTestId, "-error"),
      children: /*#__PURE__*/_jsx(UIText3, {
        color: "text-negative-default",
        children: errorMessage
      })
    })]
  });
};